import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import logoTB from 'assets/img/brand/logo_mini.png';
import Select from 'react-select';

const InitPageLayout = ({ children }) => {
  return (
    <Fragment>
      <Helmet>
        <title>Textback.ai</title>
        <link rel='icon' type='image/png' href={logoTB} sizes='16x16' />
      </Helmet>

      {children}

      {/* Hack: for load css from react-select */}
      <Select className='d-none css-load-for-select-multi-checkbox this-will-not-affect-anything' />
    </Fragment>
  );
};

export default InitPageLayout;
